<ng-template #iconTemplate>
  <rt-icon [name]="icon!" />
</ng-template>

<ng-template
  #itemTemplate
  let-active="active"
  let-iconActive="iconActive"
  let-textActive="textActive"
>
  @if (icon || leftSlot) {
    <span
      class="item-icon"
      [class.active]="active"
      [iconColor]="active || iconActive ? 'colorIconPrimaryDefault' : 'colorIconDefault'"
      [class.iconActive]="active || iconActive"
    >
      <ng-container
        [ngTemplateOutlet]="leftSlot ?? iconTemplate"
        [ngTemplateOutletContext]="leftSlotContext"
      />
    </span>
  }
  @if (draggable && !sidebarMinimized) {
    <rt-icon
      [class.active]="iconActive"
      class="drag-icon"
      name="drag-vertical"
      [colorToken]="iconActive ? 'colorIconPrimaryDefault' : 'colorIconDefault'"
      [size]="dragIconSize"
    />
  }
  @if (!sidebarMinimized) {
    <div class="top-wrapper">
      <div #itemName class="item-name" [class.with-icon]="icon" [class.text-active]="textActive">
        {{ name }}
      </div>
      @if (bottomSlot) {
        <div class="bottom-slot">
          <ng-container *ngTemplateOutlet="bottomSlot; context: bottomSlotContext!" />
        </div>
      }
    </div>
    @if (rightSlot) {
      <div #rightOutletOrigin="rtOverlayOrigin" rt-overlay-origin class="right-slot">
        <ng-container *ngTemplateOutlet="rightSlot; context: rightSlotContext!" />
      </div>
    }
  }
</ng-template>

@if (!url) {
  <div
    [rtTooltip]="name"
    [rtTooltipEnabled]="(sidebarMinimized && tooltipEnabled) || isTooltipEnabledFn"
    [class.minimized]="sidebarMinimized"
    [class.large]="bottomSlot && !sidebarMinimized"
    [class.active]="active"
    [class.draggable]="draggable"
    [class.light]="light"
    [class.hoverable]="hoverable"
    [class.right-slot-active]="rightSlot"
    rtTooltipPosition="right"
    class="wrapper"
    [@activeAnimation]="activeAnimation"
    (@activeAnimation.done)="activeAnimationDone.emit()"
  >
    @if (activeStateIndicatorEnabled) {
      <div class="active-state-indicator"></div>
    }
    <ng-container
      [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ active, iconActive, textActive }"
    />
  </div>
}

@if (url) {
  <a
    #rla="routerLinkActive"
    [routerLink]="url"
    [queryParams]="queryParams"
    routerLinkActive="active"
    [rtTooltip]="name"
    [rtTooltipEnabled]="(sidebarMinimized && tooltipEnabled) || isTooltipEnabledFn"
    [class.minimized]="sidebarMinimized"
    [class.large]="bottomSlot && !sidebarMinimized"
    [class.active]="active"
    [class.draggable]="draggable"
    [class.light]="light"
    [class.hoverable]="hoverable"
    [class.right-slot-active]="rightSlot"
    [rtcAnalyticsTrack]="analyticsEvent"
    [rtcAnalyticsTrackData]="analyticsEventData"
    rtTooltipPosition="right"
    class="wrapper"
    [@activeAnimation]="activeAnimation"
    (@activeAnimation.done)="activeAnimationDone.emit()"
  >
    @if (activeStateIndicatorEnabled) {
      <div class="active-state-indicator"></div>
    }
    <ng-container
      [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ active: rla.isActive, iconActive: iconActive }"
    />
  </a>
}
